import AxiosInterceptor from './axios'
import RouterInterceptor from './router'

export default {

}